import { FuseNavigationItem } from '@fuse/components/navigation';
import { commonNavigation } from './apps/common/common.navigation';
import { iamNavigation } from './apps/iam/iam.navigation';
import { oAuthNavigation } from './apps/o-auth/o-auth.navigation';
import { messageNavigation } from './apps/message/message.navigation';
import { queueManagerNavigation } from './apps/queue-manager/queue-manager.navigation';
import { scoutsNavigation } from '@apps/scouts/scouts.navigation';
import { toolsNavigation } from './apps/tools/tools.navigation';

export const adminNavigation: FuseNavigationItem[] = [
    scoutsNavigation,
    commonNavigation,
    iamNavigation,
    oAuthNavigation,
    messageNavigation,
    queueManagerNavigation,
    toolsNavigation
];